import { put, takeLatest, call } from 'redux-saga/effects';
import * as venueService from '../../../services/venueService';
import {
  DELETE_VENUE_LOG,
  DELETE_VENUE_LOG_SUCCESS,
  DELETE_VENUE_LOG_ERROR,
} from '../../actions/venue';

function* deleteVenueLogSaga(action) {
  try {
    const data = yield call(venueService.DeleteVenueLog, action.payload);
    yield put({
      type: DELETE_VENUE_LOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: DELETE_VENUE_LOG_ERROR,
      error: error.data,
    });
  }
}

export function* deleteVenueLogSagaWatcher() {
  yield takeLatest(DELETE_VENUE_LOG, deleteVenueLogSaga);
}
